module.exports = __webpack_public_path__ + "static/media/software-updates.a0eee9e8.svg";